import uuid from 'uuid'
import notification from 'modules/app-core/notification-manager'
import {
  createRequest,
  connectRequest,
  getRequestByName,
} from 'modules/redux-gateway'
import { actions, selectors, constants } from 'modules/notes'
import NotesModal from 'modules/notes/components/NotesModal'
import {
  constants as tagConstants,
  selectors as tagSelectors,
  actions as tagActions,
} from 'modules/tags'
import SortFunc from 'helpers/sort-func'

const newNote = {
  ItemType: constants.NOTE_TYPE,
}

const addNameToArr = (note, arr) => {
  if (
    !arr.some(
      (item) =>
        note.AuthorFirstName === item.id.AuthorFirstName &&
        note.AuthorLastName === item.id.AuthorLastName
    )
  ) {
    arr.push({
      id: {
        AuthorFirstName: note.AuthorFirstName,
        AuthorLastName: note.AuthorLastName,
      },
      name: ''.concat(note.AuthorFirstName, ' ', note.AuthorLastName),
    })
  }
}

const sortArr = {
  CreatedDateDesc: new SortFunc().by('CreatedDate').dateFormat,
  CreatedDateAsc: new SortFunc().by('CreatedDate').dateFormat.asc,
}

export default connectRequest({
  route: constants.NOTE_ALL_GET,
  clearOnMount: true,
  requestOnMountParams: ({ personId, params = {} }) => ({
    personPublicKey: personId || params.id,
  }),
  onSuccess: (request, dispatch) => {
    dispatch(actions.toggleCanPostNote(false))
    dispatch(actions.loadNotes(request.response))
    dispatch(actions.setNoteMax(Math.min(5, request.response.length)))
    const ItemPublicKeys = request.response.map((note) => note.Id)
    dispatch(tagActions.fetchAllTags(ItemPublicKeys, constants.NOTE_TYPE))
    dispatch(actions.setFilterStr('CreatedDateDesc'))
  },
  onFailure: (request, dispatch) => {
    dispatch(
      notification.actions.createErrorNotification(
        'Sorry, there was an error retrieving Employee Notes.'
      )
    )
  },
  mapStateToProps: (state, props) => {
    const noteLoading = selectors.noteLoading(state)
    const noteReq = getRequestByName(state, constants.NOTE_ALL_GET)
    const unfilteredNotesList = selectors.getNoteList(state) || []
    const dates = selectors.getDates(state) || {}
    const noteAuthors = [
      {
        id: {
          AuthorFirstName: '',
          AuthorLastName: '',
        },
        name: 'All',
      },
    ]
    const includeTags = tagSelectors
      .getTags(state, 'filtered')
      .filter((tag) => tag.IsActive)
      .map((tag) => tag.name)
    const filteredNotesList = unfilteredNotesList.filter((note) => {
      if (
        dates.startDate &&
        Date.parse(note.CreatedDate) <= Date.parse(dates.startDate.toDate())
      ) {
        return false
      }
      if (
        dates.endDate &&
        Date.parse(note.CreatedDate) >= Date.parse(dates.endDate.toDate())
      ) {
        return false
      }
      if (includeTags.length === 0) {
        addNameToArr(note, noteAuthors)
        return true
      }
      const tags = tagSelectors.getTags(state, note.Id)
      if (includeTags.includes('Untagged') && tags.length === 0) {
        addNameToArr(note, noteAuthors)
        return true
      }
      const filtered = includeTags.every((tag) =>
        tags.map((t) => t.name).includes(tag)
      )
      if (filtered) {
        addNameToArr(note, noteAuthors)
        return true
      }
      return false
    })

    const notesLength = filteredNotesList.length
    const noteMax = selectors.noteMax(state)
    const filter = selectors.filterStr(state) || ''
    const hasMoreNotes = noteMax < notesLength
    const sortedNoteList = filter
      ? filteredNotesList.sort(sortArr[filter].compare)
      : filteredNotesList
    const noteList = sortedNoteList.slice(0, noteMax)

    const handleViewMore = () => {
      props.dispatch(actions.setNoteMax(Math.min(notesLength, noteMax + 5)))
    }

    const refreshTagList = (tagInfo) => {
      props.dispatch(actions.clearPostNote(false))
      const allTags = tagSelectors.getTags(state, tagInfo.ItemPublicKey) || {}
      props.dispatch(tagActions.updatingTags(tagInfo.ItemPublicKey))
      const tags = allTags.filter((tag) => tag.IsActive).map((tag) => tag.name)
      props
        .dispatch(
          createRequest({
            route: tagConstants.TAGS_POST,
            body: {
              Tags: tags,
              ...tagInfo,
            },
          })
        )
        .then(
          () => {
            props.dispatch(tagActions.loadTags(allTags, tagInfo.ItemPublicKey))
          },
          () => {
            props.dispatch(
              notification.actions.createErrorNotification(
                'Sorry, there was an error posting Tags for this Note.'
              )
            )
          }
        )
    }
    return {
      newNote,
      noteList,
      hasMoreNotes,
      handleViewMore,
      isProcessing: noteReq.isProcessing,
      isPostingNote: selectors.isPostingNote(state),
      addNote: selectors.canPostNote(state),
      refreshTagList,
      noteLoading,
      noteAuthors,
      filterValues: filter ? sortArr[filter].values : {},
      startDate: dates ? dates.startDate : new Date(),
      endDate: dates ? dates.endDate : new Date(),
    }
  },
  mapDispatchToProps: (dispatch, props) => ({
    toggleAddNote: () => {
      newNote.ItemPublicKey = uuid()
      newNote.PersonPublicKey = props.personId
      dispatch(actions.toggleCanPostNote(true))
      dispatch(tagActions.editTags(newNote.ItemPublicKey))
    },
    clearTags: ({ item }) => {
      dispatch(tagActions.loadTags([], item))
    },
    toggleSort: (str) => () => {
      dispatch(actions.setFilterStr(str))
    },
    handleChange: (datename) => (date) => {
      dispatch(actions.setDate(datename, date))
    },
    expandAll: (bool) => () => {
      dispatch(actions.setExpandAll(bool))
    },
  }),
})(NotesModal)
